export type ShipmentStatus = 
  | 'pending' 
  | 'in_transit' 
  | 'out_for_delivery' 
  | 'delivered' 
  | 'exception' 
  | 'returned';

// Base interface with all possible field names
export interface Shipment {
  id: number;
  // Handle both snake_case and camelCase for all fields
  tracking_number?: string;
  trackingNumber?: string;
  origin: string;
  destination: string;
  weight: number;
  zone_id?: number;
  zoneId?: number;
  status: ShipmentStatus;
  customer_id?: number;
  customerId?: number;
  driver_id?: number | null;
  driverId?: number | null;
  created_at?: string;
  createdAt?: string;
  updated_at?: string;
  updatedAt?: string;
  customer_name?: string;
  customerName?: string;
  driver_name?: string;
  driverName?: string;
  zone_name?: string;
  zoneName?: string;
  tracking_events?: TrackingEvent[];
  trackingEvents?: TrackingEvent[];
  notes?: string;
}

// Extended interface with helper methods
export interface ShipmentWithHelpers extends Shipment {
  // Helper methods to get values in a consistent format
  getTrackingNumber(): string;
  getCustomerName(): string;
  getDriverName(): string;
  getZoneName(): string;
  getTrackingEvents(): TrackingEvent[];
}

// Implementation of the helper methods
export const createShipmentWithHelpers = (shipment: Shipment): ShipmentWithHelpers => {
  return {
    ...shipment,
    getTrackingNumber() {
      return this.tracking_number || this.trackingNumber || `SHIP-${this.id}`;
    },
    getCustomerName() {
      return this.customer_name || this.customerName || 'N/A';
    },
    getDriverName() {
      return this.driver_name || this.driverName || 'N/A';
    },
    getZoneName() {
      return this.zone_name || this.zoneName || 'N/A';
    },
    getTrackingEvents() {
      return this.tracking_events || this.trackingEvents || [];
    }
  };
};

export interface CreateShipmentDto {
  origin: string;
  destination: string;
  weight: number;
  zone_id?: number | null;
  customer_id: number;
  driver_id?: number | null;
  status?: string;
  notes?: string | null;
}

export interface UpdateShipmentStatusDto {
  status: ShipmentStatus;
  notes?: string;
}

export interface TrackingEvent {
  id: number;
  shipment_id: number;
  status: ShipmentStatus;
  location: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface ShipmentWithTracking extends ShipmentWithHelpers {
  tracking_events: TrackingEvent[];
  trackingEvents?: TrackingEvent[];
}

export interface ShipmentFilterParams {
  status?: ShipmentStatus;
  driver_id?: number;
  customer_id?: number;
  start_date?: string;
  end_date?: string;
  search?: string;
  tracking_number?: string;
  trackingNumber?: string; // Alias for tracking_number (camelCase version)
  page?: number;
  limit?: number;
  _sort?: string;
  _order?: 'asc' | 'desc';
  // Allow any other string keys for API query params
  [key: string]: any;
}
